"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FiPackage, FiTrash2 } from "react-icons/fi";
import { formatCurrency } from "@/lib/format-data";
import { PackageShopCartLine } from "@/types/shop";
interface PackageCartRowProps {
  line: PackageShopCartLine;
  onRemove?: () => void;
}

/**
 * Visual identity for a package cart line. Quantity controls and subtotal
 * chrome are supplied by the generic cart surfaces.
 */
const PackageCartRow: React.FC<PackageCartRowProps> = t0 => {
  const $ = _c(31);
  const {
    line,
    onRemove
  } = t0;
  const savings = line.snapshot.packageSavings ?? 0;
  const packageValue = line.unitPriceCents + savings;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mt-0.5 flex h-10 w-10 flex-none items-center justify-center rounded-full bg-primary/10 text-primary"><FiPackage className="h-5 w-5" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== line.quantity) {
    t2 = line.quantity > 1 && <span className="ml-2 text-body font-normal text-foreground-secondary">× {line.quantity}</span>;
    $[1] = line.quantity;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== line.snapshot.name || $[4] !== t2) {
    t3 = <div className="font-medium text-foreground">{line.snapshot.name}{t2}</div>;
    $[3] = line.snapshot.name;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== line.unitPriceCents) {
    t4 = formatCurrency(line.unitPriceCents);
    $[6] = line.unitPriceCents;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = line.quantity > 1 ? " each" : "";
  let t6;
  if ($[8] !== t5) {
    t6 = <span>{t5}</span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="mt-0.5 text-body text-foreground-secondary">{t4}{t6}</div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t7) {
    t8 = <div className="min-w-0 flex-1">{t3}{t7}</div>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== line.snapshot.name || $[17] !== onRemove) {
    t9 = onRemove && <button type="button" onClick={onRemove} aria-label={`Remove ${line.snapshot.name} from cart`} className="flex h-7 w-7 flex-none cursor-pointer items-center justify-center rounded text-foreground-secondary transition-colors hover:bg-hover hover:text-status-error-text focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"><FiTrash2 className="h-3.5 w-3.5" /></button>;
    $[16] = line.snapshot.name;
    $[17] = onRemove;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="flex items-start gap-2">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== line.snapshot.description) {
    t11 = line.snapshot.description && <p className="line-clamp-2 whitespace-pre-line text-caption text-foreground-secondary">{line.snapshot.description}</p>;
    $[22] = line.snapshot.description;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== packageValue || $[25] !== savings) {
    t12 = savings > 0 && <p className="text-caption font-medium text-primary">Includes {formatCurrency(packageValue)} in value · you save{" "}{formatCurrency(savings)}</p>;
    $[24] = packageValue;
    $[25] = savings;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t12) {
    t13 = <div className="flex flex-1 items-start gap-3">{t1}<div className="min-w-0 flex-1 space-y-1.5">{t10}{t11}{t12}</div></div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
};
export default PackageCartRow;